import { getGanttVisibleRange } from "../../utils/gantt-utils"

type GanttZoomRange = {
  start: Date
  end: Date
}
type MakeOnAfterSectionResizeArgs = {
  ganttZoomRange?: GanttZoomRange
}

const GANTT_SECTION_ID = 1

export const makeOnAfterSectionResize =
  ({ ganttZoomRange = getGanttVisibleRange() }: MakeOnAfterSectionResizeArgs = {}) =>
  (grid: TGrid, sectionId: 0 | 1 | 2) => {
    if (grid && sectionId === GANTT_SECTION_ID) {
      grid.ZoomTo(ganttZoomRange.start, ganttZoomRange.end)
    }
  }
